import React from "react"
import '../index.css'
export default function(props){
    return <div className = "purpleCircle">
        <span className="numberText">{props.number}</span>
    </div>
}